import { render, staticRenderFns } from "./TemplateSectionTable.vue?vue&type=template&id=9853b2de"
import script from "./TemplateSectionTable.vue?vue&type=script&lang=js"
export * from "./TemplateSectionTable.vue?vue&type=script&lang=js"
import style0 from "./TemplateSectionTable.vue?vue&type=style&index=0&id=9853b2de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports